/**
 * Tooltip shown on the aria-disabled comment actions (like/reaction, resolve)
 * for view-only actors. Single source of truth so the copy can't drift
 * between the reaction icons and the action rail.
 */
export const VIEW_ONLY_COMMENT_TOOLTIP =
  'Ask an admin to update your permissions to interact with this comment.'
